// src/components/onboarding/screens/ActivitesScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { CheckboxItem, ScreenTitle } from '../OnboardingUI';
import { activitesOptions, TOTAL_STEPS } from '../onboardingData';

const ActivitesScreen = ({ activites, onChange, onNext, loading, error }) => {
  const toggleActivite = (value) => {
    const newActivites = activites.includes(value)
      ? activites.filter(v => v !== value)
      : [...activites, value];
    onChange(newActivites);
  };

  const canProceed = activites.length > 0;

  return (
    <OnboardingLayout
      currentStep={1}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle
        title="En dehors des cours, qu'est-ce qui t'intéresse ?"
        subtitle="Coche tout ce qui te parle"
      />

      <div className="flex-1 overflow-y-auto mb-4 pr-1">
        {activitesOptions.map(option => (
          <CheckboxItem
            key={option.label}
            checked={activites.includes(option.label)}
            label={`${option.emoji} ${option.label}`}
            onClick={() => toggleActivite(option.label)}
            disabled={loading}
          />
        ))}
      </div>
    </OnboardingLayout>
  );
};

export default ActivitesScreen;
